import type { HeardAboutStat } from "../../types/types";

export const buildHeardAboutStatsEndpoint = (
  endpoint: string,
  from = "",
  to = "",
) => {
  const params = new URLSearchParams();
  if (from) params.set("from", from);
  if (to) params.set("to", to);
  const query = params.toString();
  return query ? `${endpoint}?${query}` : endpoint;
};

export const getHeardAboutDisplayName = (stat: HeardAboutStat) =>
  stat.is_disabled ? `${stat.name} (معطل)` : stat.name;

export const getHeardAboutPieData = (stats: HeardAboutStat[]) =>
  stats
    .filter((stat) => stat.total_users > 0)
    .map((stat) => ({
      id: stat.category_id ?? "unanswered",
      label: `${getHeardAboutDisplayName(stat)} (${stat.percentage.toFixed(2)}%)`,
      value: stat.total_users,
    }));
